import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { ModalService, ModalSize } from '@freelancer/ui/modal';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';
import { ToastAlertService } from '@freelancer/ui/toast-alert';
import { GroupTypeApi } from 'api-typings/groups/groups';
import { CreatableGroups } from '../create-new-group.types';

@Component({
  selector: 'app-create-new-group-button',
  template: `
    <fl-button
      i18n="Create a group button"
      class="CreateButton"
      flTrackingSection="CreateGroupButtonComponent"
      flTrackingLabel="CreateGroupButton"
      [color]="disabled ? ButtonColor.DEFAULT : buttonColor"
      [display]="'flex'"
      [disabled]="disabled"
      [busy]="loading"
      [size]="alwaysShowFullButton ? ButtonSize.SMALL : ButtonSize.MINI"
      [sizeTablet]="ButtonSize.SMALL"
      (click)="openModal()"
    >
      <fl-icon
        class="CreateButton-icon"
        [color]="disabled ? IconColor.FOREGROUND : IconColor.WHITE"
        [flMarginRight]="'xxxsmall'"
        [name]="'ui-plus-thin'"
        [size]="IconSize.XSMALL"
      ></fl-icon>
      Create
      <fl-text
        class="CreateButton-extra"
        [class.Disabled]="disabled"
        [flShowDesktop]="alwaysShowFullButton ? undefined : true"
        [color]="disabled ? FontColor.INHERIT : FontColor.LIGHT"
        [weight]="FontWeight.INHERIT"
        [size]="TextSize.INHERIT"
      >
        Group
      </fl-text>
    </fl-button>
  `,
  styleUrls: ['./create-new-group-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateNewGroupButtonComponent {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  FontColor = FontColor;
  FontWeight = FontWeight;
  IconColor = IconColor;
  IconSize = IconSize;
  TextSize = TextSize;

  /** If set to true, the + icon and extra text will always be shown, no matter the screen size. */
  @Input() alwaysShowFullButton = false;
  @Input() buttonColor: ButtonColor = ButtonColor.SECONDARY;
  @Input()
  loading?: boolean = false;
  @Input() disabled = false;
  @Input() disableModal = false;
  @Input() defaultGroupType: CreatableGroups = GroupTypeApi.COMMUNITY;

  constructor(
    private modalService: ModalService,
    private toast: ToastAlertService,
  ) {}

  openModal(): void {
    if (this.disableModal) {
      return;
    }

    this.modalService
      .open('CreateNewGroupModal', {
        mobileFullscreen: true,
        size: ModalSize.SMALL,
        closeable: true,
        inputs: {
          groupTypes: [GroupTypeApi.COMMUNITY],
        },
      })
      .afterClosed()
      .then(showToast => {
        if (showToast) {
          this.toast.open('community_created');
        }
      });
  }
}
